export default __webpack_public_path__ + "static/media/banner_4b.f14bb2d7.jpg";